import React, { useEffect } from 'react';
import { Container, Card, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  sectionHeader: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
    background: theme.palette.primary.main,
    color: 'white'
  },
  result: {
    height: '100%'
  },
  complete: {
    backgroundColor: 'white',
    height: '80vh !important'
  },
  completePaper: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  gridContainer: {
    justifyContent: 'center',
    width: '100%'
  }
}));

const Step3 = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/');
  }, []);
  const classes = useStyles();
  return (
    <Container container className={classes.gridContainer}>
      <Card className={classes.complete}>
        <div className={classes.completePaper}>
          <CircularProgress
            style={{
              fontSize: 120,
              marginBottom: 20,
              width: 80,
              height: 80
            }}
            color="primary"
          />
        </div>
      </Card>
    </Container>
  );
};


export default Step3;